export { SUPPORTED_LOCALES as locales, FALLBACK_LOCALE as fallbackLocale, isLocale, type Locale } from "@/config/locale.constants";

export const cookieName = "NEXT_LOCALE";